import React, { useState, useEffect } from 'react'
import styles from './nav-bar-style.module.css'
import { Link, useMatch, useResolvedPath } from 'react-router-dom'
import ProfilePicViewer from '../Account/ProfilePicViewer'
import { ReactComponent as MenuSVG } from './menu-button.svg';
import { ACCOUNT_LOADING, useAuth, signOutOfFirebase } from '../firebase/firebase'

const NAV_BAR_CONFIGS = {
    chautauqua_administration: [
        {text: 'Home', path: '/home'}, 
        {text: 'Calendar', path: '/calendar'}, 
        {text: 'Matrix List', path: '/matrix-list'},
        {text: 'Housekeeping', path: '/housekeeping'},
        {text: 'Admin', path: '/admin'}
    ],

    chautauqua_development: [
        {text: 'Home', path: '/home'}, 
        {text: 'Calendar', path: '/calendar'}, 
        {text: 'Matrix List', path: '/matrix-list'},
        {text: 'Housekeeping', path: '/housekeeping'},
        {text: 'Admin', path: '/admin'}
    ],

    basic: [
        {text: 'Home', path: '/home'}, 
        {text: 'Calendar', path: '/calendar'}, 
        {text: 'Matrix List', path: '/matrix-list'}
    ],

    chautauqua_housekeeping: [
        {text: 'Home', path: '/home'}, 
        {text: 'Calendar', path: '/calendar'}, 
        {text: 'Matrix List', path: '/matrix-list'},
        {text: 'Housekeeping', path: '/housekeeping'},
    ]
}

const ICON_MAP = {
    'Housekeeping': '/images/icons/housekeeping.svg',
    'Matrix List': '/images/icons/matrix.svg',
    'Calendar': '/images/icons/calendar.svg',
    'Admin': '/images/icons/admin.svg',
    'Home': '/images/icons/home.svg'
}

function NavBar({profileDropdownVisible, setProfileDropdownVisible}) {
    const [, accountData] = useAuth();
    const [sidebarVisible, setSidebarVisible] = useState(false);

    var navBarConfig = NAV_BAR_CONFIGS.basic;

    if(accountData !== ACCOUNT_LOADING && accountData != null) {
        var navBarKey = accountData.account_type.split(' ')[0].toLowerCase() + "_" + accountData.account_area.split(' ')[0].toLowerCase();
        navBarConfig = NAV_BAR_CONFIGS[navBarKey];

        if(navBarConfig == null)
            navBarConfig = NAV_BAR_CONFIGS.basic;
    }

    const onProfileClicked = () => { setProfileDropdownVisible(!profileDropdownVisible)};

    return (
        <nav className={styles.nav}>
            <div className={styles.nav_content}>
                <MenuSVG fill="#FFFFFF" onClick={() => setSidebarVisible(!sidebarVisible)} id={styles.menu_button}/>
                <ProfilePicViewer id='nav_bar_profile_pic' profilePic={accountData?.profile_pic} firstInitial={accountData?.first_name?.[0]} size={48} onPicClicked={() => onProfileClicked()}/>
            </div>
            
            <div id={styles.profile_dropdown} className={profileDropdownVisible ? styles.down : styles.up}>
                <h1>Hello, {accountData?.first_name}!</h1>
                <p>Signed in as: {accountData?.email}</p>
                <div className='divider'/>
                <Link onClick={() => setProfileDropdownVisible(false)} to='account-settings'>Account Settings</Link>
                <div className='divider'/>
                <a onClick={() => signOutOfFirebase()} href='signin'>Sign Out</a>   
                <div className='divider' id={styles.bottom}/>          
            </div>

            <div id={styles.sidebar} className={sidebarVisible ? '' : styles.hidden}>
                <Link to="/home" onClick={() => setSidebarVisible(false)}>
                    <img src='/images/logo/chautauqua-interconnect-banner2.svg' alt="Chautauqua Interconnect logo" className={styles.banner_image}/>
                </Link>
                <div className='divider'/>
                {
                    navBarConfig.map((item) => 
                        <React.Fragment key={item.text}>
                            <MenuItem to={item.path} name={item.text} sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible}/>
                            <div className="divider"></div>
                        </React.Fragment>
                    )
                }                
            </div>
            <div id={styles.blocker} className={sidebarVisible ? '' : styles.hidden} onClick={() => setSidebarVisible(false)}/>
        </nav>
    );
}

function MenuItem({to, name, sidebarVisible, setSidebarVisible}) {
    const [icon, setIcon] = useState(ICON_MAP[name]);
    const resolvedPath = useResolvedPath(to);
    const isActive = useMatch({path: resolvedPath.pathname, end: true});

    useEffect(() => {
        if (name === 'Matrix List') {
            if (sidebarVisible && Math.random() < 0.01)
                setIcon('/images/icons/neo.svg');
            else
                setIcon('/images/icons/matrix.svg');
        }
            
    }, [sidebarVisible])


    return (
        <Link to={to} className={`${styles.menu_item} ${(isActive) ? styles.active : ''}`} onClick={() => setSidebarVisible(false)}>
            <img src={icon}/>
            <h3>{name}</h3>
        </Link>
    );
}

export default NavBar;